<template>
  <page-layout title="실적통계">
    <template v-slot:search>
      <loan-statics-search-bar
        @search="getSearch"
      />
    </template>
    <template v-slot:table>
      <loan-statics-detail
        :params-data="paramsData"
        :data="data"
        :loading="loading"
      />
    </template>
  </page-layout>
</template>
<script>
import PageLayout from "@/common/layout/PageLayout.vue";
import LoanStaticsSearchBar from "@/pages/Loan/components/LoanStatics/LoanStaticsSearchBar.vue";
import LoanStaticsDetail from "@/pages/Loan/components/LoanStatics/LoanStaticsDetail.vue";
import {axiosInstance} from "@/util/AxiosModule";
import _ from "lodash";

export default{
  name: "LoanStatics",
  components: {LoanStaticsDetail, LoanStaticsSearchBar, PageLayout},
  data() {
    return {
      paramsData: {},
      data: {},
      loading: false
    }
  },
  mounted() {
    this.getSearch({yyyy: new Date().getFullYear(), type: "M"});
  },
  methods: {
    async getSearch(params) {
      this.paramsData = params;
      this.loading = true;
      try {
        const { data } = await axiosInstance.get("/admin/performance/performance-year", { params });
        if (_.isEmpty(data)) {
          this.data = [];
        } else {
          this.data = data;
        }
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
      this.loading = false;
    }
  }
}
</script>